function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.988 6.145c-4.974 0-8.313 2.908-8.313 8.555v4.023a3.718 3.718 0 011.61-.369c.583 0 1.134.139 1.627.378V14.7c0-3.662 2.01-5.544 5.076-5.544 3.067 0 5.076 1.882 5.076 5.544v8.794h3.237V14.7c0-5.68-3.338-8.555-8.313-8.555zM41.771 13.297c-.648-2.69-2.864-4.155-5.592-4.155-2.797 0-4.91 1.498-5.559 4.155h11.151zM27.108 15c0-5.109 3.751-8.855 9.07-8.855 5.32 0 9.003 3.746 9.003 8.855v1.192H30.518c.478 2.997 2.728 4.666 5.66 4.666 2.183 0 3.718-.681 4.707-2.145h3.58c-1.296 3.133-4.365 5.142-8.286 5.142-5.32 0-9.07-3.746-9.07-8.855zM61.438 15c0-3.406-2.31-5.858-5.775-5.858-3.465 0-5.775 2.452-5.775 5.858 0 3.406 2.31 5.858 5.775 5.858 3.465 0 5.775-2.452 5.775-5.858zm-14.812 0c0-5.109 3.737-8.855 9.037-8.855 5.299 0 9.036 3.746 9.036 8.855s-3.737 8.855-9.036 8.855c-5.3 0-9.036-3.746-9.036-8.855zM83.133 26.855h.376c2.089 0 2.876-.917 2.876-3.293V6.867h3.254v16.491c0 4.142-1.644 6.28-5.822 6.28h-.684v-2.783zM69.61 17.115a.825.825 0 00-.15.476c0 .453.357.818.802.818h7.998V7.977a.798.798 0 00-.556-.793.997.997 0 00-.288-.04c-.195 0-.436.07-.635.342l-7.17 9.627-.002.002zm11.844 8.186H78.26v-4.008h-8.098c-1.616 0-3.019-.806-3.66-2.103-.6-1.214-.437-2.653.436-3.851l7.278-9.704c1.049-1.437 2.808-2.007 4.478-1.446 1.672.56 2.755 2.078 2.76 3.868V18.41h2.401v2.884h-2.401V25.3z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M85.301 0h5.422v5.422h-5.422V0z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#aura-ds_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M85.301 2.711a2.714 2.714 0 002.711 2.71 2.714 2.714 0 002.711-2.71A2.714 2.714 0 0088.012 0a2.714 2.714 0 00-2.71 2.711z",
  fill: "#fff"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 14.458h13.012V30H0V14.458z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#aura-ds_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.22 19.473c-.63 0-1.21.21-1.677.558l-3.07-2.071c.068-.238.107-.487.107-.746 0-1.52-1.252-2.756-2.79-2.756-1.54 0-2.791 1.236-2.791 2.756 0 1.52 1.252 2.756 2.79 2.756.63 0 1.21-.21 1.678-.558l3.07 2.071a2.714 2.714 0 00-.107.746c0 .258.038.508.106.745l-3.07 2.072a2.795 2.795 0 00-1.676-.559c-1.54 0-2.791 1.237-2.791 2.757S1.25 30 2.789 30c1.539 0 2.79-1.236 2.79-2.756 0-.259-.038-.508-.105-.745l3.07-2.072a2.795 2.795 0 001.676.558c1.54 0 2.791-1.236 2.791-2.756 0-1.52-1.252-2.756-2.79-2.756z",
  fill: "#fff"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M103.899 21.802c2.186 0 4.053-1.07 4.85-3.074v2.778h1.412V15.95c0-3.552-2.482-5.989-6.034-5.989-3.552 0-6.057 2.482-6.057 5.989 0 3.598 2.664 5.852 5.829 5.852zm.228-1.412c-2.687 0-4.509-1.913-4.509-4.508 0-2.596 1.822-4.509 4.509-4.509 2.687 0 4.509 1.913 4.509 4.509 0 2.595-1.822 4.508-4.509 4.508zm17.256 1.412c3.324 0 5.556-1.935 5.556-5.67v-5.875h-1.526v5.875c0 2.755-1.594 4.258-4.03 4.258-2.437 0-4.031-1.503-4.031-4.258v-5.875h-1.525v5.875c0 3.735 2.231 5.67 5.556 5.67zm12.747-.296v-6.74c0-2.346 1.275-3.393 3.211-3.393 1.912 0 3.21 1.047 3.21 3.393v.16h1.503v-.137c0-3.257-1.913-4.828-4.713-4.828-2.801 0-4.737 1.571-4.737 4.805v6.74h1.526zm18.235.296c2.186 0 4.053-1.07 4.85-3.074v2.778h1.412V15.95c0-3.552-2.482-5.989-6.035-5.989-3.552 0-6.057 2.482-6.057 5.989 0 3.598 2.665 5.852 5.83 5.852zm.227-1.412c-2.687 0-4.508-1.913-4.508-4.508 0-2.596 1.821-4.509 4.508-4.509 2.687 0 4.509 1.913 4.509 4.509 0 2.595-1.822 4.508-4.509 4.508zM168.386 21.687c4.035 0 6.195-2.339 6.195-5.838 0-3.5-2.16-5.838-6.195-5.838h-4.178v11.676h4.178zm0-1.178h-2.892v-9.32h2.892c3.303 0 4.909 1.857 4.909 4.66s-1.606 4.66-4.909 4.66zM182.886 21.919c2.571 0 4.249-1.375 4.249-3.553 0-2.324-1.776-2.78-3.547-3.077l-.171-.028-.057-.01-.114-.018-.057-.009c-1.588-.25-3.052-.5-3.052-2 0-1.374 1.071-2.267 2.767-2.267 1.678 0 2.695.857 2.767 2.196h1.232c-.072-2.035-1.643-3.374-3.999-3.374-2.41 0-4.017 1.41-4.017 3.481 0 2.134 1.505 2.697 3.13 2.983l.114.02c.17.029.342.055.513.08l.114.016.056.008.232.034.115.018c1.451.226 2.724.56 2.724 1.983 0 1.428-1.142 2.339-2.999 2.339-1.857 0-2.946-.857-2.999-2.34h-1.268c.054 2.179 1.732 3.518 4.267 3.518z",
  fill: "#fff"
});

function SvgAuraDs(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 188 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "aura-ds_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 0,
    width: 6,
    height: 6
  }, _ref3), _ref4, /*#__PURE__*/React.createElement("mask", {
    id: "aura-ds_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 14,
    height: 16
  }, _ref5), _ref6, _ref7);
}

export default SvgAuraDs;